import { render, staticRenderFns } from "./EvoucherInstro.vue?vue&type=template&id=4d5c584d&scoped=true&"
import script from "./EvoucherInstro.vue?vue&type=script&lang=js&"
export * from "./EvoucherInstro.vue?vue&type=script&lang=js&"
import style0 from "./EvoucherInstro.vue?vue&type=style&index=0&id=4d5c584d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c584d",
  null
  
)

export default component.exports